import { Component, NgZone, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../shared/services/api.service';
import { GridOptions, ColDef, GridApi } from 'ag-grid-community';

@Component({
  standalone: false,
  selector: 'app-currency',
  templateUrl: './currency.component.html',
  styleUrl: './currency.component.scss'
})
export class CurrencyComponent {

  count = 0;
  dataObj: any = {};
  modalRef: any;
  gridApi: any;
  content: any;
  type = 'currency';
  apiUrl: any;
  errorMessage: string = '';

  columnDefs: ColDef[] = [
      {
      headerName: 'Action',
      field: 'action',
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.classList.add('btn', 'btn-sm', 'btn-outline-primary', 'ps-4', 'pe-4', 'rounded-pill');
        button.innerHTML = '<i class="bi bi-eye"></i>';
        button.addEventListener('click', () => this.onEdit(params));
        return button;
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      editable: false,
      filter: true,
      cellRenderer: (params: any) => {
        const span = document.createElement('span');
        span.classList.add('badge', params.value === 'Active' ? 'bg-success' : 'bg-danger');
        span.textContent = params.value || 'Inactive';
        return span;
      },
    },
  
    {
      headerName: 'Name',
      field: 'name',
      editable: false,
      filter: true,
      width: 250
    },
    {
      headerName: 'Short Name',
      field: 'shortName',
      editable: false,
      filter: true,
    },
     {
      headerName: 'Symbol',
      field: 'symbol',
      editable: false,
      filter: true,
    },
    
  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };


  constructor(
    private _modal: NgbModal,
    private _api: ApiService,
    private zone: NgZone
  ) { }

  ngOnInit(): void {

  }

  onGridReady(params: any) {
    const vm = this;
    console.log(params);
    vm.gridApi = params.api;
    if (vm.gridApi) {

      vm.gridApi.sizeColumnsToFit();
    }
    this.gridApi.sizeColumnsToFit();
  }

  refreshGrid() {
    const vm = this;
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;
        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        vm.apiUrl = '/admin/get-data?type=' + vm.type + '&_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + filterData[k].filter;
          }
        });
         vm._api.getData(vm.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            vm.count = res.count;
            console.log(vm.count);
            console.log(res);
            // Sort currency list alphabetically by name
            const sortedData = res.data.sort((a: any, b: any) => {
              const nameA = a.name.toLowerCase();
              const nameB = b.name.toLowerCase();
              if (nameA < nameB) return -1;
              if (nameA > nameB) return 1;
              return 0;
            });
            params.successCallback(sortedData, res.count);
            //vm.gridApi.sizeColumnsToFit();
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  addNew(content: any) {
    const vm = this;
    vm.dataObj = {};
    //this.content = content;
    console.log(vm.content);
    vm.modalRef = vm._modal.open(this.content, { backdrop: 'static', size: 'lg' });
  }

  onEdit(data: any) {
    this.zone.run(() => {
      this.dataObj = { ...data.data };
      console.log(this.dataObj, 'datattt');
      this.modalRef = this._modal.open(this.content, { backdrop: 'static', size: 'lg' });
    });
  }

  setContent(c: any) {
    this.content = c;
  }

   onSubmit(flag: any) {
    this.errorMessage = '';
    this.dataObj['type'] = this.type;
    const apiUrl = this.dataObj._id ? '/admin/edit-data' : '/admin/new-data';
    this._api.postData(apiUrl, this.dataObj).subscribe({
      next: (res: any) => {
        if (res && !res.error) {
          this.onClose();
          this.dataObj = {};
          if (this.gridApi) {
            this.gridApi.refreshInfiniteCache();
          }
        } else {
          this.errorMessage = res.message || 'Failed to save currency';
        }
      },
      error: (err: any) => {
        this.errorMessage = (err.error && err.error.message) || err.message || 'Failed to save currency';
      }
    });
  }

  onClose() {
    if (this.modalRef) {
      this.modalRef.close();
    }
    this.dataObj = {};
  }

}
